import type { Language } from '@kerberos-compliance/compliance-shared-ts/common/i18n/enums/language.enums';
import type { Gender } from '../enums/gender.enum';

export enum Industry {
  RealEstate = 'realEstate',
  TradeInGoods = 'tradeInGoods',
  PreciousMetalDealers = 'preciousMetalDealers',
  SportsBettingLandbasedAgents = 'sportsBettingLandbasedAgents',
  EMoneyAgentsAgents = 'eMoneyAgentsAgents',
  CapitalManagementCompanies = 'capitalManagementCompanies',
}

export type User = {
  uid: string;
  email: string;
  displayName?: string | null;
  firstName: string;
  lastName: string;
  gender: Gender;
  preferredLanguage: Language; // only used initially to save to UserProfile
  industry: Industry;
};
